import Vue from "vue";
import ElementUI from "element-ui";

import "element-ui/lib/theme-chalk/index.css";
// import "element-ui/lib/theme-chalk/row.css";

Vue.use(ElementUI);

export default Vue;
